<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Add from "./add";
import Show from "./show";
import { mapGetters } from 'vuex';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "المستندات",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Add, Show, VueContentLoading},
  data() {
    return {
     
      title: "المستندات",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "المستندات",
          active: true,
        },
      ],

      canAdd: false,
      canShow: false,
      loadingContent: true
    };
  },
  computed:{
    ...mapGetters('auth', ['getUser'])
  },
  created(){
    this.canAdd  = this.getUser.hasPermission('add_image');
    this.canShow = this.getUser.hasAnyPermission(['show_image','edit_image','delete_image']);
  },
  mounted() {
    setTimeout(() => {
      this.loadingContent = false;
    }, 1000);
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">

          <div v-if="!loadingContent" class="card-body">

            <b-tabs v-if="this.canAdd && canShow" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bxs-file-plus"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">اضافة مستند جديد</span>
                </template>

                <Add />

              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bxs-file-doc"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">عرض المستندات</span>
                </template>

                <Show />
                
              </b-tab>
            </b-tabs>

            <Show v-else-if="canShow" />
            <Add v-else-if="canAdd" />
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="130">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />
              
              <rect x="10" y="24" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="28" rx="1" ry="1" width="380" height="10" />

              <rect x="10" y="43" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="47" rx="1" ry="1" width="360" height="10" />
              <rect x="371" y="47" rx="1" ry="1" width="19" height="10" />

              <rect x="10" y="62" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="66" rx="1" ry="1" width="380" height="35" />

              <rect x="10" y="107" rx="1" ry="1" width="380" height="1" />
              <rect x="10" y="111" rx="1" ry="1" width="20" height="10" />
            </vue-content-loading>
          </div>

        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>